export default __webpack_public_path__ + "static/media/hot_tub.7afbfa5c.svg";